import { render, staticRenderFns } from "./WealthPortfolioWithdrawCompleted.vue?vue&type=template&id=2341f68b&scoped=true&"
import script from "./WealthPortfolioWithdrawCompleted.vue?vue&type=script&lang=ts&"
export * from "./WealthPortfolioWithdrawCompleted.vue?vue&type=script&lang=ts&"
import style0 from "./WealthPortfolioWithdrawCompleted.vue?vue&type=style&index=0&id=2341f68b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2341f68b",
  null
  
)

export default component.exports